import { defineMessages } from 'react-intl';

export const i18n: {
	attachedDateLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	attachmentLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	audioLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	expandLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	imageLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pdfLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	videoLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	attachedDateLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Indicates the date the attachment was added',
	},
	expandLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.expand.label',
		defaultMessage: 'Expand',
		description: 'Icon label to expand the attachment',
	},
	attachmentLabel: {
		id: 'dynamic-cards-search-page.search-result.attachment-label',
		defaultMessage: 'Attachment',
		description:
			'Label for message attachments shown below the message search result, for example "Attachment • 12/29/2025"',
	},
	pdfLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.pdf-label',
		defaultMessage: 'PDF',
		description:
			'Label for attachments shown below the message search result, for example "PDF • 12/29/2025"',
	},
	videoLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.video-label',
		defaultMessage: 'Video',
		description:
			'Label for video attachments shown below the message search result, for example "Video • 12/29/2025"',
	},
	imageLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.image-label',
		defaultMessage: 'Image',
		description:
			'Label for image attachments shown below the message search result, for example "Image • 12/29/2025"',
	},
	audioLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.audio-label',
		defaultMessage: 'Audio',
		description:
			'Label for audio attachments shown below the message search result, for example "Audio • 12/29/2025"',
	},
});
